import { Field, ErrorMessage } from 'formik';
import { FieldEntityProps, FieldClassNameInterface } from '../types';

interface AccessibleTextFieldProps {
  type: string;
  field: FieldEntityProps;
  placeholder: string;
  textFieldClassNames: FieldClassNameInterface;
  isTouchedAndError: boolean;
  isRequired: boolean;
  showErrorMessages?: boolean;
}

const AccessibleTextField = ({
  type,
  field,
  placeholder,
  textFieldClassNames,
  isTouchedAndError,
  isRequired,
  showErrorMessages = false,
}: AccessibleTextFieldProps) => {
  const errorClass = isTouchedAndError ? 'errorBorder' : '';
  const errorId = `${field.parameterName}-error`;

  return (
    <>
      <Field
        type={type.toLowerCase()}
        name={field.parameterName}
        id={field.parameterName}
        placeholder={placeholder}
        className={`${textFieldClassNames.mainField} ${errorClass}`}
        aria-label={field.name}
        aria-required={isRequired}
        aria-invalid={isTouchedAndError}
        aria-describedby={
          showErrorMessages && isTouchedAndError ? errorId : undefined
        }
      />
      {showErrorMessages && (
        <ErrorMessage name={field.parameterName}>
          {(msg) => (
            <div
              id={errorId}
              role="alert"
              className={isTouchedAndError ? 'errorMessage' : 'errorHide'}
            >
              {msg}
            </div>
          )}
        </ErrorMessage>
      )}
    </>
  );
};

export default AccessibleTextField;
